import { createVanIconComponent } from "./van"

const ManagerOutlined = createVanIconComponent("manager-o")
export default ManagerOutlined
